<template>
  <div class="tw-flex tw-flex-col">
    <base-credit-card-input class="tw-mt-3" ref="creditCardInput" />
    <div class="tw-flex tw-justify-end">
      <div>
        <base-button size="xs" type="secondary" @click="submit" :disabled="isLoading" :loading="isLoading">
          Save Card
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userId: String,
    businessId: String,
    userBusinessPlanId: String,
    userBusinessPlans: Array,
    isStandAlone: Boolean,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    reset() {
      this.$refs.creditCardInput.reset();
    },
    cancel() {
      this.reset();
      this.$emit("canceled");
    },
    async submit() {
      this.isLoading = true;

      let token = await this.$refs.creditCardInput.createToken();
      if (!token) {
        this.isLoading = false;
        return;
      }

      let url;
      //business CC
      if (this.businessId && !this.userId && !this.userBusinessPlanId) url = `/businesses/${this.businessId}/creditcard`;
      //business update user card
      else if (this.businessId && this.userId && this.userBusinessPlans) {
        this.updateAllBusinessPlanCards();
        return;
      } else if (this.businessId && this.userId && this.userBusinessPlanId)
        url = `/businesses/${this.businessId}/members/${this.userId}/plans/${this.userBusinessPlanId}/creditcard`;
      //user update cards
      else if (this.userId && !this.businessId && !this.userBusinessPlanId) url = `/users/${this.userId}/creditcard`;
      else if (this.userId && this.userBusinessPlanId && !this.businessId) url = `/users/${this.userId}/plans/${this.userBusinessPlanId}/creditcard`;

      this.$axios
        .put(url, {
          stripeToken: token.id,
        })
        .then(() => {
          this.reset();
          this.$emit("updated");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Payment Card Updated", message: "You successfully updated your card information" });
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", { title: "Update Failed", message: "Your card update failed", error: err });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateAllBusinessPlanCards() {
      for (const planId of this.userBusinessPlans) {
        let token = await this.$refs.creditCardInput.createToken();
        if (!token) return;

        this.$axios
          .put(`/businesses/${this.businessId}/members/${this.userId}/plans/${planId}/creditcard`, {
            stripeToken: token.id,
          })
          .then(() => {
            this.reset();
            this.$emit("updated");
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Payment Card Updated", message: "You successfully updated your card information" });
          })
          .catch((err) => {
            this.EventBus.$emit("GLOBAL_ERROR", { title: "Update Failed", message: "Your card update failed", error: err });
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
